/**
 * DEAD SIGNAL — Chapter loader (ADR-0001)
 *
 * Resolves a chapter id to its module via dynamic import (Vite emits each as a
 * separate chunk), validates the contract, registers it as the active chapter,
 * and returns it. The boot sequence awaits loadChapter() before the playable
 * scenes render.
 */
import { validateChapter } from './contract.js';
import { setActiveChapter } from '../activeChapter.js';

const LOADERS = {
  1: () => import('./chapter1/index.js'),
  2: () => import('./chapter2/index.js'),  // synthetic on-demand-load proof + template
};

export function chapterExists(id) {
  return Object.prototype.hasOwnProperty.call(LOADERS, id);
}

export async function loadChapter(id) {
  const key = chapterExists(id) ? id : 1;
  const mod = await LOADERS[key]();
  const chapter = validateChapter(mod.chapter ?? mod.default);
  setActiveChapter(chapter);
  return chapter;
}
